/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import BarChartRenderer from "components/charts/bar-chart-renderer";
import ColumnChartRenderer from "components/charts/column-chart-renderer";
import PieChartRenderer from "components/charts/pie-chart-renderer";
import TableRenderer from "./custom-table-renderer";
import AreaChartRenderer from "components/charts/area-chart-renderer";
import LineChartRenderer from "components/charts/line-chart-renderer";
import NumberRenderer from "components/charts/number-renderer";

/**
 * Style dependencies
 */
import "./styles.scss";

const ChartFactory = ({ chartType, ...props }) => {
  switch (chartType) {
    case "NUMBER":
      return <NumberRenderer {...props} />;
    case "AREA":
      return <AreaChartRenderer {...props} />;
    case "LINE":
      return <LineChartRenderer {...props} />;
    case "TABLE":
      return <TableRenderer {...props} />;
    case "PIE":
      return <PieChartRenderer {...props} />;
    case "BAR":
      return <BarChartRenderer {...props} />;
    case "COLUMN":
      return <ColumnChartRenderer {...props} />;
    default:
      return <BarChartRenderer {...props} />;
  }
};

export default ChartFactory;
